module.exports = __webpack_public_path__ + "static/gwl-banner-desktop-fde6298ec82fb101f95026e7a5459b45.jpg";